import React, { useContext } from 'react';
import AppContext from './AppContext';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from './components/Card';

function PokedexFlavorTextCard() {
  const {
    GenusFlavorText,
    clickedSpeciesId,
  } = useContext(AppContext);

  const { ftext } = GenusFlavorText[clickedSpeciesId] || {};
  if (ftext == null || ftext === undefined) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Flavor Text</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-xs">
          {ftext}
        </div>
      </CardContent>
    </Card>
  );
}

export default PokedexFlavorTextCard;
